export const getDashBoardData = async (conn, callback, reject) => {
  await conn
    .get('/monitor/userStat/list')
    .then(response => {
      const totalCnt = {
        total: 0,
        normal: 0,
        warn: 0,
        danger: 0,
        unOper: 0,
      };
      response.forEach(element => {
        // 카운터 작업
        if (element.meainStatCode === 20001) {
          totalCnt.normal += 1;
        } else if (element.meainStatCode === 20002) {
          totalCnt.warn += 1;
        } else if (element.meainStatCode === 20003) {
          totalCnt.unOper += 1;
        } else if (element.meainStatCode === 20004) {
          totalCnt.danger += 1;
        }
      });
      // 총합 갯수
      totalCnt.total = totalCnt.normal + totalCnt.warn + totalCnt.danger + totalCnt.unOper;
      // 결과 객체 생성
      const result = { totalCnt: totalCnt, dataSource: response };
      callback(result);
    })
    .catch(error => {
      reject(error);
    });
};
